"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "pt": {
        "translation": {
            "global_navigation": {
                "navigation_items": {
                    "logo": "Voltar para o Launchpad",
                    "app_switcher": "Alternar Aplicativos",
                    "announcer": "Lançamentos",
                    "helper": "Ajuda e Suporte",
                    "user": "Entrou: {{username}}",
                    "user_with_customer": "{{username}} {{customerName}}",
                    "sign_in": "Entrar"
                },
                "apps": {
                    "academy": "Academia",
                    "community": "Comunidade",
                    "projects": "Projetos",
                    "results": "Resultados",
                    "storyboards": "Storyboards",
                    "mission_control": "Controle da Missão",
                    "risks": "Estratégia",
                    "reports": "Relatórios",
                    "launchpad": "Launchpad",
                    "robots": "Robôs",
                    "frameworks": "Estruturas",
                    "compliance_maps": "Mapas de Conformidade",
                    "assurance_plans": "Planos de Garantia",
                    "project_scheduler": "Agendador",
                    "issue_tracker": "Rastreador de Problemas",
                    "task_tracker": "Rastreador de Tarefas",
                    "project_timesheets": "Quadros de Horário",
                    "dashboard": "Painel do {{module}}",
                    "master_library": "Biblioteca Principal"
                },
                "app_sections": {
                    "setup": "Configuração",
                    "workspace": "Área de trabalho",
                    "automation": "Automação"
                },
                "user": {
                    "my_profile": "Meu Perfil",
                    "log_out": "Efetuar Logout"
                },
                "helper": {
                    "help_docs": "Documentos de Ajuda",
                    "support": "Suporte"
                },
                "skip_button": "Ir para conteúdo principal",
                "logo": "logotipo",
                "other": "Outro",
                "section": "seção"
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=pt.js.map